export default "__VITE_ASSET__6c6695a1__"